<template>

	<div class="modal">

		<div class="modal-wrap">

			<div class="modal-inner">

				<h2 class="modal-title">{{ title }}<span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">

					<p v-if="!results.results||results.results.length===0">Sorry there are no results to display.</p>

					<div
						v-for="(result, resultIndex) in results.results" 
        				:key="resultIndex" 
        				class="results"
					>

						<a 
							:href="result.url" 
							target="_blank" 
							:class="{result:true,featured:result.type==='featured_snippet',map:result.type==='maps_search'}" 
							v-if="result.type==='organic'||result.type==='featured_snippet'||result.type==='maps_search'"
						>

							<h2 class="result-title" v-html="result.title" />
							<img :src="result.main_image" v-if="result.type==='maps_search'&&!!result.main_image" />
							<p v-html="result.description" v-if="result.description" />

							<span v-html="result.url" class="url" />

						</a>

						<span v-if="typeof result.related_result === 'object' && Array.isArray(result.related_result)">

							<a 
								:href="result.url" 
								target="_blank" 
								class="result indented"
								v-for="(related, relatedIndex) in result.related_result" 
        						:key="resultIndex+'-'+relatedIndex" 
							>

								<h2 class="result-title" v-html="related.title" />
								<p v-html="related.description" />

								<span v-html="related.url" class="url" />

							</a>

						</span>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import { mapMutations } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
export default {
	name: 'SERPresults',
	props: {
		results: {
			type: Object
		}
	},
	data() {

		return {
			
		}

	},
	computed: { 
		title () {

			return 'Search Results: ' + this.results.keyword;

		}

    },
	methods: {

		...mapMutations('general',['updateLoadingText']),

		close () {

			this.$emit('close');

		}

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.results {

	.result {

		text-decoration: none;
		color: @textGrey;
		margin-bottom: 30px;
		display: block;

		img {

			max-width: 200px;
			width: 100%;
			height: auto;
			margin-bottom: 6px;

		}

		&.featured {

			border: 1px solid #eaedf0;
    		background-color: #f8fafb;
		    border-radius: 8px;
		    padding: 10px 15px;
		    position: relative;

		    &:after {

		    	content: "Featured";
			    top: 0;
			    position: absolute;
			    right: 0;
			    font-size: 10px;
			    padding: 3px 5px;
			    opacity: 0.5;

		    }

		}

		&.indented {

			margin-left: 30px;

		}

		.result-title {

			font-weight: normal;
			padding: 0 0 0.2em;
			margin: 0;
			font-size: 1.3em;

		}

		p {

			padding: 0 0 0.2em;
			margin: 0;

		}

		.url {

			display: block;
			color: @formDefaultColour;
			word-break: break-all;

		}

	}

}
</style>